import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

import Careers from "./pages/Careers";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetails from "./components/Services/ServiceDetails";
import Contact from "./pages/Contact";
import Login from "./components/Login/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import VerifyCertificate from "./components/VerifyCertificate/VerifyCertificate";
import Checkout from "./components/checkout/checkout";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const API_BASE = "http://localhost:5000/api";

/* 🔹 Wrapper Layout */
function Layout() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:id" element={<ServiceDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/verify-certificate" element={<VerifyCertificate />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/careers" element={<Careers />} />
      </Routes>

      <Footer />
    </>
  );
}

/* 🔹 Main App */
function App() {
  return (
    <Router>
      {/* GLOBAL TOAST CONTAINER */}
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        theme="colored"
      />

      <Layout />
    </Router>
  );
}

export default App;
